export default {
    // initialization of the app
    currentPage: '',
    userCurrentLocation: 'My+Location',
    loggedUser: '',
    loggedToken: '',
};
